//RequestUser
export const REQUEST_USER_DICTIONARY = [
  { options: "dept", save: { store: false, self: true }, load: "store" },
  { options: "priority", entityName: 'priority', serviceName: 'BaseService', save: { store: false, self: true }, load: "db" },
  { options: "request_type", entityName: 'request_type', serviceName: 'BaseService', save: { store: false, self: true }, load: "db" },
  { options: "request_state", entityName: 'request_state', serviceName: 'BaseService', save: { store: false, self: true }, load: "db" },
  { options: "user", save: { store: false, self: true }, load: "self", keyName: "user_sname", valueName: "user_sname" },
  { options: "developer", save: { store: false, self: true }, load: "self", keyName: "developer_sname", valueName: "developer_sname" }
];
export const REQUEST_USER_TOOLBAR_FILTRES = [
  {
    name: "periods",
    enabled: true,
    required: true,
    attrList: { showTime: true, date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } },
    default: "За квартал",
  },
  {
    name: "lookup",
    caption: "Заявки",
    enabled: true,
    default: 0,
    required: true,
    params: ["my_ticket"],
    attrList: {
      optionLabel: "name",
      optionValue: "id",
      options: [
        { id: 1, name: "Только мои" },
        { id: 0, name: "Все" },
      ],
    },
  }
];
export const REQUEST_USER_COLUMNS = [{
  header: "Ид",
  field: "request_user_id",
  sortable: true,
  bodyStyle: "text-align: right;",
  filterData: {
    type: "InputText",
    "max-width": "60px",
    placeholder: "...",
    attrList: { type: "number", step: "1" },
  },
},
{
  header: "Дата",
  field: "create_date",
  sortable: true,
  dataType: "date-gmt",
  conversion: true,
  filterData: {
    type: "Calendar",
    mode: "dateIsGMT",

    attrList: { dateFormat: "dd.mm.yy" },
  },
},
{
  header: "Подразделение",
  field: "company_name",
  sortable: true,
  filterData: {
    options: "dept",
    type: "MultiSelect",
    valueName: "dept_name",
    mode: "in",
    "max-width": "250px",
  },
},
{
  header: "Заявитель",
  field: "user_sname",
  sortable: true,
  filterData: {
    options: "user",
    type: "MultiSelect",
    mode: "in",
    attrList: { filter: true },
    "max-width": "250px",
  },
},
{
  header: "Приоритет",
  field: "priority_name",
  sortable: true,
  filterData: {
    options: "priority",
    type: "MultiSelect",
    mode: "in",
    "max-width": "250px",
  },
},
{
  header: "Тип",
  field: "request_type_name",
  sortable: true,
  filterData: {
    options: "request_type",
    type: "MultiSelect",
    mode: "in",
    "max-width": "250px",
  },
},
{
  header: "Наимнование",
  field: "request_user_name",
  sortable: true,
  filterData: {
    type: "InputText",
  },
},
{
  header: "Статус",
  field: "request_state_name",
  sortable: true,
  filterData: {
    options: "request_state",
    type: "MultiSelect",
    mode: "in",
    "max-width": "250px",
  },
},
{
  header: "Исполнитель",
  field: "developer_sname",
  sortable: true,
  filterData: {
    options: "developer",
    type: "MultiSelect",
    mode: "in",
    attrList: { filter: true },
    "max-width": "250px",
  },
}];

//RequestUserDialog
export const FILE_COLUMNS = [{
  header: "Тип",
  field: "file_type_name",
  dataType: "image-text",
  imageField: "icon_index",
},
{
  header: "Дата",
  field: "file_date",
  dataType: "date",
  conversion: true
},
{
  header: "Имя файла",
  field: "file_name",
},
{
  header: "Описание",
  field: "file_desc",
},
{
  header: "Размер, кб",
  field: "file_size",
},];